import { Component } from '@angular/core';
import { TourService } from 'map-wald-leaflet';
import { environment } from '../environments/environment';
import { AnalyticsService } from 'map-wald';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'frontend';
  environment = environment;
  existingCookie = false;
  constructor(tours:TourService,private analytics:AnalyticsService) {
    tours.initialise(environment);
    this.existingCookie = analytics.hasCookie();
  }

  cookieDecision(accepted:boolean){
    this.analytics.enabled = accepted;
    if(accepted){
      gtag('config', environment.gaKey);
    }
  }
}
